<div class="modal-content">
    <div class="modal-header">
      <h1 class="modal-title pull-left" id="my-modal-title">{{'ASSISTING_PERSON_TYPES_HEADER' | globalTranslate}}</h1>
      <button type="button" class="btn-close pull-right" [attr.aria-label]="'CLOSE' | globalTranslate" (click)="onCancel()">
        <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon"/>
      </button>
    </div>
    <div class="modal-body">
      <table class="table table-striped d-none d-lg-block modal-table">
        <thead>
          <tr class="header-sty">
            <th scope="col">{{'ASSISTING_PERSON_TYPES' | globalTranslate}}</th>
            <th scope="col">{{'ASSISTING_PERSON_DESCRIPTION' | globalTranslate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{'AUTHORIZED_REPRESENTATIVE' | globalTranslate}}</td>
            <td>{{'AUTHORIZED_REPRESENTATIVE_DESCRIPTION' | globalTranslate}}</td>
          </tr>
          <tr>
            <td>{{'CONSERVATOR' | globalTranslate}}</td>
            <td>{{'CONSERVATOR_DESCRIPTION' | globalTranslate}}</td>
          </tr>
          <tr>
            <td [ngStyle]="globalLang === 'de' ? {'overflow-wrap': 'break-word'} : {}">{{'LEGAL_GUARDIAN' | globalTranslate}}</td>
            <td>{{'LEGAL_GUARDIAN_DESCRIPTION' | globalTranslate}}</td>
          </tr>
          <tr>
            <td>{{'POWER_OF_ATTORNEY' | globalTranslate}}</td>
            <td>{{'POWER_OF_ATTORNEY_DESCRIPTION' | globalTranslate}}</td>
          </tr>
        </tbody>
      </table>
      <div class="nh-table-mobile d-lg-none">
        <div class="mobile-table-header">{{'AUTHORIZED_REPRESENTATIVE' | globalTranslate}}</div><hr>
        <div class="mobile-table-data">{{'AUTHORIZED_REPRESENTATIVE_DESCRIPTION' | globalTranslate}}</div><br>
        <div class="mobile-table-header">{{'CONSERVATOR' | globalTranslate}}</div><hr>
        <div class="mobile-table-data">{{'CONSERVATOR_DESCRIPTION' | globalTranslate}}</div><br>
        <div class="mobile-table-header">{{'LEGAL_GUARDIAN' | globalTranslate}}</div><hr>
        <div class="mobile-table-data">{{'LEGAL_GUARDIAN_DESCRIPTION' | globalTranslate}}</div><br>
        <div class="mobile-table-header">{{'POWER_OF_ATTORNEY' | globalTranslate}}</div><hr>
        <div class="mobile-table-data">{{'POWER_OF_ATTORNEY_DESCRIPTION' | globalTranslate}}</div><br>
      </div>
    </div>
  </div>